import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Receipt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 1.5H5.25C4.42192 1.50083 3.75083 2.17192 3.75 3V21.75C3.75 22.1642 4.08579 22.5 4.5 22.5H5.25C5.4861 22.5001 5.70844 22.3889 5.85 22.2L7.5 20.0002L9.15 22.2C9.29744 22.3796 9.51761 22.4837 9.75 22.4837C9.98239 22.4837 10.2026 22.3796 10.35 22.2L12 20.0002L13.65 22.2C13.7974 22.3796 14.0176 22.4837 14.25 22.4837C14.4824 22.4837 14.7026 22.3796 14.85 22.2L16.5 20.0002L18.15 22.2C18.2916 22.3889 18.5139 22.5 18.75 22.5H19.5C19.9142 22.5 20.25 22.1642 20.25 21.75V3C20.2492 2.17192 19.5781 1.50083 18.75 1.5ZM18.75 20.4998L17.1 18.3C16.9526 18.1204 16.7324 18.0163 16.5 18.0163C16.2676 18.0163 16.0474 18.1204 15.9 18.3L14.25 20.4998L12.6 18.3C12.4526 18.1204 12.2324 18.0163 12 18.0163C11.7676 18.0163 11.5474 18.1204 11.4 18.3L9.75 20.4998L8.1 18.3C7.95256 18.1204 7.73239 18.0163 7.5 18.0163C7.26761 18.0163 7.04744 18.1204 6.9 18.3L5.25 20.4998V3H18.75V20.4998ZM17.25 12H15.75V13.5H17.25V12ZM6.75 12H12.75V13.5H6.75V12ZM17.25 9H15.75V10.5H17.25V9ZM6.75 9H12.75V10.5H6.75V9ZM17.25 6H6.75V7.5H17.25V6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Receipt.vue"]]);
